/*
 * @Author: lubo10 lubo10@hikvision.com.cn
 * @Date: 2023-05-23 09:35:33
 * @LastEditors: lubo10 lubo10@hikvision.com.cn
 * @LastEditTime: 2023-05-23 13:34:07
 * @FilePath: \city-h5\src\api\map.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '../utils/service'

const api = {
  getNearbyParks: function(data) {
    return request({
      url: '/dealer/v2/api/nearbyParks',
      method: 'get',
      params: data
    })
  },
  getNearbyDiffTimeParks: function(data) {
    return request({
      url: '/dealer/v2/api/nearbyDiffTimeParks',
      method: 'get',
      params: data
    })
  },
  getCityList: function() {
    return request({
      url: '/dealer/v2/api/citys',
      method: 'get'
    })
  },
  getConfigs: function() {
    return request({
      url: '/basic/v2/api/paramConfigs',
      method: 'get'
    })
  },
  getNearbyStations: function(data) { // 充电站
    return request({
      url: '/cps/v2/api/nearbyStations',
      method: 'get',
      params: data
    })
  },
  getMapType: function() { // 获取默认地图类型高德、百度
    return request({
      url: '/basic/v2/api/sysCodes/getMapType',
      method: 'get'
      // params: data
    })
  },
  getNearbyBookParks: function(data) {
    return request({
      url: '/dealer/v2/api/nearByBookParks',
      method: 'post',
      data: data
    })
  }
}

export default api
